import PlaceHolderStripes from 'assets/images/placeholder_stripes.gif';
import ImagesLoaded from 'imagesloaded';

export default class MediaUploadBase {

  constructor(options) {
    this.learnEditor = options.editor;

    this.savedImageUrl;
    this.savedAltText;
    this.savedCaption;
    this.activeElementId = null;
    this.activePosition = null;

    if (this.shouldShowButton()) {
      this.addListeners();
    }
  }

  addListeners() {
    const action = (navigator.userAgent.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on(action, `.license-build-${this.elementBaseClass()}`, this.updateImageLicense.bind(this));
    $(document).on(action, `.alt-build-${this.elementBaseClass()}`, this.add_image_alt_attribute.bind(this));
    $(document).on(action, `.caption-build-${this.elementBaseClass()}`, this.add_image_caption.bind(this));
    $(document).on(action, `.delete-build-${this.elementBaseClass()}`, this.deleteMedia.bind(this));
    $(document).on(action, `.build-${this.elementBaseClass()} > a`, function(event) {
      event.preventDefault();
    });

    this.learnEditor.$element.on('save-page-complete', this.addImageModifiers.bind(this));
    this.learnEditor.$element.on('disabled', this.disableImageModifiers.bind(this));
    this.learnEditor.$element.on('enabled', this.enableImageModifiers.bind(this));
    this.learnEditor.$element.on('editor-loaded', this.addImageModifiers.bind(this));
    this.learnEditor.$element.on('button-bar-added', this.addFileUploadToButtonBar.bind(this))

    this.addCustomListeners();

    var that = this;
    // this executes on the response for license submission when the user has no default license
    $(document).on('ajax:success', '.edit_media_asset', function(event, data, status, xhr) {
      var response = xhr.responseText;

      $('#licenseModal').modal('hide');

      var $result = $(response);

      if (!$.trim(response) && (xhr.status === 200)) {
        //license type was updated for an image
        that.learnEditor.set_publish_text("License Set");
        return;
      }

      that.place_build_image($(response));
      that.learnEditor.save_page("Before Add Image Element");
    });
  }

  disableImageModifiers() {
    $(`.add-${this.elementBaseClass()}`).fileupload('disable').prop('disabled', true);
  }

  enableImageModifiers() {
    $(`.add-${this.elementBaseClass()}`).fileupload('enable').prop('disabled', false);
  }

  //----------------
  // define in inheriting class
  //----------------

  elementBaseClass() {
    return 'image';
  }

  baseUrl() {
    return '/pages/' + this.learnEditor.pageID + '/assets/';
  }

  shouldShowButton() {
    return true;
  }

  additionalImageOption() {
    return '';
  }

  //----------------
  //----------------

  addButtonTemplate() {
    return `<span class="button fileinput-button add-image-button">
              <span><i class="fa fa-picture-o"></i>Upload</span>
              <input class="add-${this.elementBaseClass()}" class="button secondary" type="file" name="files" />
            </span>`;
  }

  addCustomListeners() {
    return;
  }

  parentContainer(target) {
    return $(target).parents(`.build-${this.elementBaseClass()}`);
  }

  addImageModifiers() {
    this.image_upload();
    this.dropzone_uploads();
  }

  deleteMedia(event) {
    event.preventDefault();

    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.activeElementId = "";
    this.activePosition = "";

    $(event.target).parents(`.build-${this.elementBaseClass()}`).remove();
    this.learnEditor.save_page("Before Deleted Image Element");
  }

  updateImageLicense(event) {
    event.preventDefault();

    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $img = this.parentContainer(event.target).find('img')
    var that = this;
    var asset = parseInt($img.attr('class'), 10);
    var url =  this.baseUrl() + asset + '/license';

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html'
    }).done(function(data) {
      // the crop modal is used to display the image license
      that.learnEditor.$element.after(data);
      $('#licenseModal, #cropModal').modal('show');
    });
  }

  build_image_placeholder() {
    return `<div class="row-fluid build-image-placeholder">
      <div class="la-square-jelly-box la-dark la-3x">
        <div></div>
        <div></div>
      </div>
      <div class="media">media uploading</div>
      <div class="wait">please stand by</div>
    </div>`
  }

  image_upload() {
    $.cleanData(`.add-${this.elementBaseClass()}`);

    var that = this;

    //allow multiple uploading of images
    if ($("input[name='license']").val() && $("input[name='license']").val().length > 0) {
      $(`.add-${this.elementBaseClass()}`).attr('multiple', 'multiple');
    }

    //actual upload of image, handled by jquery-fileupload plugin
    $(`.add-${this.elementBaseClass()}`).fileupload({
      dataType: 'html',
      progressInterval: 20,
      bitrateInterval: 100,
      sequentialUploads: true,
      url: this.baseUrl(),
      dropZone: null,
      add: that.image_upload_add.bind(that),
      done: that.image_upload_done.bind(that),
      error: that.image_upload_error.bind(that)
    });
  }

  image_upload_add(e, data) {
    var $button_bar = $(e.target).closest('.button-bar, .bottom-button-bar');

    if ($button_bar.length > 0 && !$(e.target).data('initial_image')) {
      $button_bar.replaceWith(this.build_image_placeholder());
      $(e.target).data('initial_image', true);
    } else if ($('.build-image-placeholder').length > 0) {
      $('.build-image-placeholder:last').after(this.build_image_placeholder());
    } else {
      $('.bottom-button-bar').replaceWith(this.build_image_placeholder());
    }

    data.submit();
  }

  image_upload_done(e, data) {
    var result = $(data.result)[0];
    if ($(result).is('#licenseModal')) {
      this.learnEditor.$element.after(result);
      $('#licenseModal').modal('show');
    } else if ($(result).is(`.build-${this.elementBaseClass()}`)) {
      var $image = $(data.result);

      ImagesLoaded($image, function() {
        this.place_build_image($image);
        this.learnEditor.save_page("Before Add Image Element");
      }.bind(this));
    } else if ($(result).is('.build-button')) {
      var $button = $(data.result);
      this.place_build_image($button);
      this.learnEditor.save_page("Before Add File Element");
    }
  }

  image_upload_error(jqXHR, textStatus, errorThrown) {
    if (jqXHR.status === 406) {
      if (jqXHR.responseText) {
        alert(jqXHR.responseText);
      } else {
        alert('The file format is not currently supported, or there was another issue with your upload.\n\n Please contact learndev@adafruit.com.');
      }
      $('.build-image-placeholder:first').remove();
      this.learnEditor.finishEditing();
    }
  }

  dropzone_uploads() {
    // ensure license is set for dropzone uploads, show alert if it's not
    if ($("input[name='license']").val() && $("input[name='license']").val().length === 0) {
      var alertShown = false;
      $(document).on('dragover', function (e) {
        if (!alertShown) {
          alertShown = true;
          alert("Set your default media license in My Account -> Learning System -> Preferences to enable drag/drop/paste uploads");
        }
      });
      return;
    }

    // fileupload method to clean bindings
    $.cleanData('.button-bar, .bottom-button-bar');
    $(document).off('dragover');

    var that = this;

    // dropzone effects
    $(document).on('dragover', function (e) {
      var dropZones = $('.button-bar, .bottom-button-bar'),
        timeout = window.dropZoneTimeout;
      if (timeout) {
        clearTimeout(timeout);
      } else {
        dropZones.addClass('in');

        var dropZoneHeight = dropZones.find('.button-bar-buttons').height();
        dropZones.find('.button-bar-buttons').hide()
        dropZones.find('.button-bar-dropzone').height(dropZoneHeight).css('display', 'flex');
      }
      var hoveredDropZone = $(e.target).closest(dropZones);
      dropZones.not(hoveredDropZone).removeClass('hover');
      hoveredDropZone.addClass('hover');
      window.dropZoneTimeout = setTimeout(function () {
        window.dropZoneTimeout = null;
        dropZones.removeClass('in hover');

        dropZones.find('.button-bar-dropzone').hide()
        dropZones.find('.button-bar-buttons').show();
      }, 100);
    });

    this.addFileUploadToElement($('.bottom-button-bar'));
  }

  addFileUploadToButtonBar() {
   this.addFileUploadToElement($('.button-bar'));
  }

  addFileUploadToElement($element) {
    var that = this;

    $element.each(function() {
      var $this = $(this);
      var pasteZone;

      if ($this.hasClass('bottom-button-bar') && $this.is($(".bottom-button-bar:last"))) {
        pasteZone = $(document);
      } else {
        pasteZone = undefined;
      }

      $this.fileupload({
        dataType: 'html',
        progressInterval: 20,
        bitrateInterval: 100,
        sequentialUploads: true,
        url: that.baseUrl(),
        dropZone: $this,
        pasteZone: pasteZone,
        fileInput: $('#drop-paste-image'),
        paste: function(e, data) {
          //$(this).fileupload('add', {files: data.files});
        },
        add: that.image_upload_add.bind(that),
        done: that.image_upload_done.bind(that),
        error: that.image_upload_error.bind(that)
      });
    })
  }

  place_build_image(content) {
    var $replace_element = $('.build-image-placeholder:first');
    var is_button_row_bar = ($('.build-image-placeholder:first').parents('.button-bar').length > 0);

    if (is_button_row_bar) {
      $replace_element = $('.build-image-placeholder:first').parents('.button-bar');
    }

    $replace_element.replaceWith(content);
  }

  add_image_alt_attribute(event) {
    event.preventDefault();

    var $build_image = this.parentContainer(event.target);

    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    let that = this;
    let $image = $('img', $build_image);
    let existingAltText = $image.attr('alt') || "";
    let altTemplate = '<div class="image-caption image-alt"><input type="text" value="' + existingAltText + '" placeholder="Enter alt attribute..." class="build-input" /><button class="editor-button">Save</button><div class="clearfix"></div></div>';

    $(document).on('click', '.image-alt button', function(event) {
      event.preventDefault();

      $(document).off('click', '.image-alt button');
      let altText = $('input', $(event.target).parent('.image-alt')).val();

      $('.image-caption', $build_image).remove();

      let assetId = $image.attr('class').match(/\d+/g).join('');

      that.save_image_alt_attribute(assetId, altText, true);
    });

    $build_image.append(altTemplate);
  }

  save_image_alt_attribute(assetId, altText, shouldSave=false) {
    let that = this;
    let assetUpdateUrl = `${this.baseUrl()}${assetId}`
    let data = { 'asset': { 'alt_attribute': altText, 'update_type': 'alt_attribute' } };

    $.ajax({
      url: assetUpdateUrl,
      type: 'PUT',
      data: data,
      success: function(response) {
        if (that.shouldSave) {
          that.learnEditor.save_page("Before Add/Edit Image Alt Attribute");
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        alert("Error saving alt attribute, please try again");
      }
    });
  }

  add_image_caption(event) {
    event.preventDefault();

    var $build_image = this.parentContainer(event.target);

    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var that = this;
    var $image_caption = $('.image-caption', $build_image);
    var existing_caption = $image_caption.html() || "";
    existing_caption = existing_caption.replaceAll('"', '&quot;');

    var caption_template = `<div class="image-caption"><input type="text" value="${existing_caption}" placeholder="Enter Caption..." class="build-input" /><button class="editor-button">Save</button><div class="clearfix"></div></div>`;

    $(document).on('click', '.image-caption button', function(event) {
      event.preventDefault();

      var caption = $('input', $(this).parent('.image-caption')).val();

      if (caption.length > 0) {
        $('.image-caption', that.parentContainer(this)).html('').text(caption);
      } else {
        $('.image-caption', that.parentContainer(this)).remove();
      }


      that.learnEditor.save_page("Before Add/Edit Image Caption");

      $(document).off('click', '.image-caption button');
    });

    if ($image_caption.length) {
      $image_caption.replaceWith(caption_template);
    } else {
      $build_image.append(caption_template);
    }

    this.learnEditor.editing();
  }
}
